<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-4">
      <div>
        <div class="section-title">{{ $tc("userJourneyFlow") }}</div>
        <div class="section-subTitle my-2">{{ $tc("viewing") }} {{ $tc("userJourneyFlow") }}</div>
        <div>
          <b-form-input
            v-debounce:300="getCustomerFlow"
            v-model="searchValue"
            :placeholder="$tc('searchs')"
          ></b-form-input>
        </div>
      </div>
      <!-- <div>
        <b-button
          variant="default"
          to="/marketing-automation/add-user-journey"
          class="btn-blue"
        >{{ $t('add') }}</b-button>
      </div> -->
      <div>
        <router-link class="btn-blue" to="/marketing/customers"
          >{{ $tc("customer", 2) }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div v-if="flowList.length > 0" class="white-wrapper">
      <ul class="journey-flow-list">
        <li v-for="(flow, flowKey) in flowList" :key="flowKey">
          <div class="row">
            <div class="col-2">
              <img
                src="@/assets/img/icons/user-male.svg"
                class="img-rounded"
                height="40"
                width="40"
              />
            </div>
            <div class="col-3">
              <!-- <div class="d-table border rounded px-3 py-2 bg-light">4:11 AM, 26 May 2020</div> -->
              <div class="d-table border rounded px-3 py-2 bg-light">
                {{ dateFormat(flow.log_date_time) }}
              </div>
            </div>
            <div class="col-4">
              <!-- <div class="d-table border rounded px-3 py-2 bg-light">Tickets Booked</div> -->
              <div class="d-table border rounded px-3 py-2 bg-light">
                {{ flow.event_name }}
                <span class="tooltip-element ml-2" v-if="showInfo(flow)">
                  <img
                    :src="require('@/assets/img/icons/question.svg')"
                    height="20"
                    width="20"
                    v-b-tooltip.hover
                    :title="getAdditionalInfo(flow)"
                    class="moreInfo"
                  />
                </span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="text-center" v-if="totalItems !== flowList.length">
        <button @click="getMore" class="btn-blue">{{ $tc("view") }} {{ $tc("more") }}</button>
      </div>
    </div>
    <div v-else class="white-wrapper text-center">{{ $tc("NoRecords") }}</div>
  </div>
</template>

<script>
import MarketingAutomation from "@/services/MarketingAutomationService";
import moment from "moment";
export default {
  data() {
    return {
      flowList: [],
      limit: 20,
      totalItems: 0,
      searchValue: ""
    };
  },
  mounted() {
    this.getCustomerFlow();
  },
  methods: {
    showInfo(Event) {
      let EventArray = [4, 5, 8, 11, 12];
      if (EventArray.includes(Event.trigger_id)) {
        return false;
      } else {
        return true;
      }
    },
    getAdditionalInfo(Event) {
      if ((Event.trigger_id == 2 || Event.trigger_id == 1) && Event.movie) {
        return `Movie - ${Event.movie}, 
        Tickets - ${Event.number_of_tickets}, 
        Seats - ${Event.seats},   
        Total - ${Event.total_value}`;
      } else if (Event.trigger_id == 3 && Event.fnb_items) {
        return `Fnb Items - ${Event.fnb_items}, 
        Qty. - ${Event.total_items}, 
        Amount - ${Event.ft_total_amount}`;
      } else if (Event.trigger_id == 9 && Event.movie) {
        return `Movie - ${Event.movie}`;
      } else if (Event.movie && Event.seats) {
        return `Movie - ${Event.movie} 
        Seats - ${Event.seats}`;
      } else if (Event.movie) {
        return `Movie - ${Event.movie}`;
      }
    },
    getCustomerFlow() {
      const { cust_id } = this.$route.params;
      MarketingAutomation.GetCustomerFlow({
        cust_id: cust_id,
        limit: this.limit,
        searchValue: this.searchValue
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.flowList = data.Records;
            this.totalItems = data.totalRows;
            console.log("this.flowList :>> ", this.flowList);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    dateFormat(date) {
      return moment(date).format("lll");
    },
    getMore() {
      this.limit += 20;
      this.getCustomerFlow();
    }
  }
};
</script>

<style>
.journey-flow-list {
  list-style: none;
}

.journey-flow-list li {
  margin-bottom: 40px;
  position: relative;
}

.journey-flow-list li::before {
  content: "";
  top: 20px;
  width: 45%;
  display: block;
  height: 1px;
  z-index: 0;
  background-color: grey;
  position: absolute;
  left: 40px;
}

.journey-flow-list li:not(:last-child)::after {
  content: " ";
  left: 20px;
  height: calc(100% - 0px);
  width: 1px;
  display: block;
  background-color: grey;
  position: absolute;
  top: 40px;
}

.journey-flow-list img {
  max-width: 100%;
  border-radius: 50%;
  overflow: hidden;
  bottom: 2px solid var(--cyan);
}
.moreInfo {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/UserJourneyComponents/viewUserJourneyFlow.vue